import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueAxios } from './utils/request'
import _ from 'lodash'


import { Button, message, Menu, Icon, PageHeader,
  Col, Row, Space, Divider, Collapse, FormModel,
  Input, Select, Breadcrumb, Form, Checkbox, notification,
  Pagination, Modal, Card, BackTop, Tag, Spin, Radio, DatePicker, Empty
} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import 'ant-design-vue/dist/antd.less'
import '@/style/twcss.css'

import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  BarChart,
  LineChart,
  ScatterChart
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  ToolboxComponent,
  DatasetComponent
} from 'echarts/components'

import './permission' // permission control

Vue.config.productionTip = false

// echart 配置
use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  ToolboxComponent,
  TitleComponent,
  LegendComponent,
  LineChart,
  DatasetComponent,
  ScatterChart
]);
Vue.component('v-chart', ECharts)

// axios配置
Vue.use(VueAxios)

// antdesign 组建按需引入
Vue.use(Button)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(PageHeader)
Vue.use(Col)
Vue.use(Row)
Vue.use(Space)
Vue.use(Divider)
Vue.use(Collapse)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Select)
Vue.use(Breadcrumb)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(Pagination)
Vue.use(Modal)
Vue.use(Card)
Vue.use(BackTop)
Vue.use(Tag)
Vue.use(Spin)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Empty)
Vue.use(notification)

Vue.prototype.$message = message;
Vue.prototype.$notification = notification
Vue.prototype.$lodash = _

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
